import { EntityConfigItem, EntityDataset } from '@nova/types';
import { ReadonlyDeep } from 'type-fest';

import { entityConfig, extendedEntityConfig } from '../configs/entities';

entityConfig satisfies ReadonlyDeep<EntityDataset>;
export type BaseEntityConfig = typeof entityConfig;
export type BaseEntityDatasetKey = keyof BaseEntityConfig;

// * The extension config extends the base, hence the base needs to be processed first and have it's keys extracted, which the extension config references.
// - Hence this structure here, being a partial of an entity config item, extending something from the base to fill-in whatever the partial left out.
// - These two lines would belong in the entity-configs-structs.ts file, but rely on the forementioned processing.
export type ExtendedEntityConfigItem = Partial<EntityConfigItem> & { extends: BaseEntityDatasetKey };
export type ExtendedEntityDataset = { [entityKey: string]: ExtendedEntityConfigItem };

extendedEntityConfig satisfies ReadonlyDeep<ExtendedEntityDataset>;
export type ExtendedEntityConfig = typeof extendedEntityConfig;
export type ExtendedEntityDatasetKey = keyof ExtendedEntityConfig;

// Both sets of keys combined, denoting any entry in either config object.
export type EntityDatasetKey = BaseEntityDatasetKey | ExtendedEntityDatasetKey;
